import HTTP from '../../script/service';

// 获取即构TOKEN, userID, userName
const getZegoToken = async (room) => {
  return new Promise((resolve, reject) => {
    const isAnonymous = room.isAnonymous();
    const params = { roomId: room.roomid, isCrypto: true };
    let URI = '_get_zrtc_token';
    let nickname = room?.uid ?? '';
    if (isAnonymous) {
      URI = '_get_zrtc_token_anonymous';
      params.anonymous = room.account;
      nickname = room.account;
    }
    HTTP[URI](params)
      .then(async (res) => {
        if (res?.code === 200) {
          const data = res.data;
          resolve({
            ...data,
            userName: `${nickname}`,
            streamIdList: data?.streamIdList ?? null,
          });
        } else {
          reject('获取失败');
        }
      })
      .catch(reject);
  });
};

export default getZegoToken;
